<script>
    import {afterUpdate, onMount} from "svelte";
    import {getEndLabel, getStartLabel, labels, mainTimeline} from "../timelines/main-timeline";
    import gsap from "gsap";

    export let scene = 0;

    const inTimeline = gsap.timeline();
    const twoOutTimeline = gsap.timeline();

    const threeOutTimeline = gsap.timeline();
    const threeInTimeline = gsap.timeline();

    const startPosition = {x: 0, y: 0};
    const endMin = 1600;
    const endMax = 50;
    const stars = Array.from(new Array(50)).map(() => randoPosition());

    const {circleStart, circleEnd} = labels;


    function drawPoint(min, max, cx, cy) {
        const angle = Math.random() * 360;
        const distance = min + max * Math.random();

        const x = cx + distance * Math.cos(- angle * Math.PI / 180);
        const y = cy + distance * Math.sin(- angle * Math.PI / 180);

        return {x, y};
    }

    function randoPosition() {
        return drawPoint(endMin, endMax, startPosition.x, startPosition.y);
    }

    const opacityConfig = {
        opacity: 0,
        duration: 1
    }

    const starsTl = gsap.timeline({repeat: -1});

    onMount(() => {

        inTimeline
            .from('.scene-two-three-container', {
                ...opacityConfig,
                onComplete: () => {
                    stars.forEach(({x, y}, i) => {
                        const delay = Math.random();

                        starsTl.from('.falling' + i, {
                            x: -x,
                            y: -y,
                            scale: 0.3,
                            duration: 1,
                            transformOrigin: '50% 50%',
                            repeat: -1
                        }, delay).to('.falling' + i, {
                            opacity: 0,
                            duration: 0.4,
                            delay: 0.6,
                            repeat: -1
                        }, '<');
                    });
                }
            });

        starsTl.play();


        // Working
        threeOutTimeline.to('.scene-two-three-container', {
            opacity: 0,
            duration: 1,
            onComplete: () => starsTl.pause(),
        })


        twoOutTimeline.to('.intro-two-container', {
            opacity: 0,
            duration: 1,
        }, 0);

        threeInTimeline.from('.intro-three-container', opacityConfig, 0);

        mainTimeline.add(inTimeline, getStartLabel(1));
        mainTimeline.add(twoOutTimeline, getEndLabel(1));
        mainTimeline.add(threeInTimeline, getEndLabel(1));
        mainTimeline.add(threeOutTimeline, getEndLabel(2));
    });

    afterUpdate(() => {
       if (scene === 1) {
           starsTl.play()
       }
    });


</script>


<g class="scene-two-three-container" transform="translate(550 400)">
    <defs>
        <filter id="blurFilter">
            <feGaussianBlur in="SourceGraphic" stdDeviation="2"/>
        </filter>
    </defs>

    <g class="intro-two-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="1100" viewBox="0 0 1151 540" y="-300" x="-140">
            <defs>
                <filter id="904u8o3ijtroilg" x="0" y="0" width="1151" height="540" filterUnits="userSpaceOnUse">
                    <feOffset input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur"/>
                    <feFlood flood-opacity="0.596"/>
                    <feComposite operator="in" in2="blur"/>
                    <feComposite in="SourceGraphic"/>
                </filter>
            </defs>
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#904u8o3ijtroilg)">
                <text transform="translate(18 18)" fill="#e3e3e3" font-size="42" font-family="Metric-Regular, Metric">
                    <tspan x="37.781" y="39">To win the biggest transformation deals, you need to understand</tspan>
                    <tspan x="52.239" y="81">how B2B firms use thought leadership to discover and evaluate</tspan>
                    <tspan x="335.441" y="123">potential business partners.</tspan>
                    <tspan x="557.5" y="165">

                    </tspan>
                    <tspan x="35" y="207">Based on a survey of 800 business executives, new research from</tspan>
                    <tspan x="35" y="249">FT Longitude sheds light on how leaders of major B2B companies</tspan>
                    <tspan x="110" y="291">select partners for strategic transformation programmes.</tspan>
                    <tspan x="557.5" y="333">

                    </tspan>
                    <tspan font-family="Metric-Medium, Metric" font-weight="500">
                        <tspan x="144.739" y="375">You can explore that new customer journey here.</tspan>
                    </tspan>
                </text>
            </g>
        </svg>

    </g>

    <g class="intro-three-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="1100" height="540" viewBox="0 0 1151 540" y="80" x="-140">
            <defs>
                <filter id="abc1022323" x="0" y="0" width="1151" height="540" filterUnits="userSpaceOnUse">
                    <feOffset input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur"/>
                    <feFlood flood-opacity="0.596"/>
                    <feComposite operator="in" in2="blur"/>
                    <feComposite in="SourceGraphic"/>
                </filter>
            </defs>
            <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#abc1022323)">
                <text transform="translate(18 18)" fill="#e3e3e3" font-size="42" font-family="Metric-Medium, Metric"
                      font-weight="500">
                    <tspan x="37.832" y="39">Your customers are on a transformation journey. But the path</tspan>
                    <tspan x="13.582" y="81">ahead is unclear and fraught with risk. They need a partner they</tspan>
                    <tspan x="168.938" y="123">can trust to help them reach their destination.</tspan>
                </text>
            </g>
        </svg>

    </g>

    <g class="falling-star-container" transform="translate(410 250)">
        {#each stars as star, i}
            <g transform={`translate(${star.x} ${star.y})`}>
                <circle
                        r=10
                        cx={0}
                        cy={0}
                        class={"falling-star falling" + i}
                        transform={`scale(${Math.random() * 0.8 + 0.2})`}
                ></circle>
            </g>
        {/each}
    </g>
</g>

<style>
    .falling-star {
        fill: white;
        filter: url('#blurFilter');
        opacity: 0.4;
    }
</style>